import { Environment } from './types';

export const environment: Environment = {
  production: false,
  apiUrl: '/api/mobile/',  //apiUrl: 'https://ambit.maxxess-systems.com/AmbitMobileApi/api/mobile/',
  apiCorsUrl: '/api/mobile/', //apiCorsUrl: 'https://ambit.maxxess-systems.com/AmbitMobileApi/api/mobile/',
  deepLinkHost: 'https://provisioning.sossoftware.com/'
};
